module.exports = "<button class=\"btn btn-primary btn-action-bar printPageBtn\" title=\"stampa\"><span class=\"icon-print\"></span></button>";